
export type GetProjectsSortBy = typeof GetProjectsSortBy[keyof typeof GetProjectsSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsSortBy = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  views: 'views',
  likes: 'likes',
  comments: 'comments',
} as const;
